// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dEoT5","col":"styles_col__3kryd"};